import { useEffect, useState } from "react";
import { Col, Form, Input, Row, Select } from "antd";
import {
  GET_BRAND_ENDPOINT,
  GET_BUYER_ENDPOINT,
  GET_BUYING_OFFICE_ENDPOINT,
  GET_STYLE_LIST_ENDPOINT,
  GET_USERS_ENDPOINT,
  GET_USERS_LIST_ENDPOINT,
  SALES_CONTRACT_LIST,
} from "../../../apiServices/API_ENDPOINTS";
import { getData } from "../../../apiServices/common";
import { isArrayAndHasValue } from "../../../utils/functions";

const cmStatusOptions = [
  { id: "0", label: "Pending" },
  { id: "1", label: "Approved" },
];

const obStatusOptions = [
  { id: "Yes", label: "Yes" },
  { id: "No", label: "No" },
];

const BuyerInquiryFilterFields = ({ initialTableData }) => {
  // States
  const [buyingOffice, setBuyingOffice] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [buyerList, setBuyerList] = useState([]);
  const [styleList, setStyleList] = useState([]);
  const [usersList, setUsersList] = useState([]);

  // Antd
  const { Option } = Select;

  // Effects
  useEffect(() => {
    // Get buying office, sales contract, buyer and style list at first load
    getBuyingOfficeList();
    getBuyerList();
    getBrandList();
    getStyleList();
    getAllUsers();
  }, []);

  const getAllUsers = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      ...filterValues,
      role_ids: [3,5]
    };
    const response = await getData(GET_USERS_LIST_ENDPOINT, false, bodyData);

    if (response && response?.data?.code === 200) {
      setUsersList(response?.data?.data?.data || []);
    }
  };

  const getBuyingOfficeList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      ...filterValues,
    };
    const response = await getData(GET_BUYING_OFFICE_ENDPOINT, false, bodyData);

    if (response && response?.data?.code === 200) {
      setBuyingOffice(response?.data?.data?.data || []);
    }
  };

  const getBuyerList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      ...filterValues,
    };
    let response = await getData(GET_BUYER_ENDPOINT, false, bodyData);

    if (response && response?.data?.code === 200) {
      setBuyerList(response?.data?.data?.data || []);
    }
  };

  const getBrandList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      ...filterValues,
    };
    let response = await getData(GET_BRAND_ENDPOINT, false, bodyData);

    if (response && response?.data?.code === 200) {
      setBrandList(response?.data?.data?.data || []);
    }
  };

  const getStyleList = async (filterValues) => {
    const bodyData = {
      per_page: filterValues?.per_page || 20,
      ...filterValues,
    };
    const response = await getData(GET_STYLE_LIST_ENDPOINT, false, bodyData);

    if (response && response?.data?.code === 200) {
      setStyleList(response?.data?.data?.data || []);
    }
  };

  return (
    <>
      <Col span={4}>
        <Form.Item label="Inquiry No." name="inquiry_no">
          <Input placeholder="Write Inquiry No." size="small" />
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Buying Office" name="buying_office_id">
          <Select
            showSearch
            placeholder="Select a Buying Office"
            onSearch={(value) => {
              getBuyingOfficeList({ name: value });
            }}
            optionFilterProp="children"
            size="small"
          >
            {isArrayAndHasValue(buyingOffice) &&
              buyingOffice.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Buyer" name="buyer_id">
          <Select
            showSearch
            placeholder="Select a Buyer"
            onSearch={(value) => {
              getBuyerList({ name: value });
            }}
            optionFilterProp="children"
            size="small"
          >
            {buyerList?.length &&
              buyerList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Brand" name="brand_id">
          <Select
            showSearch
            placeholder="Select a Brand"
            onSearch={(value) => {
              getBrandList({ name: value });
            }}
            optionFilterProp="children"
            size="small"
          >
            {brandList?.length &&
              brandList.map((sup) => (
                <Option value={sup.id} key={sup.id}>
                  {sup.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Style" name="style_id">
          <Select
            showSearch
            placeholder="Select a Style"
            onSearch={(value) => {
              getStyleList({ style_no: value });
            }}
            optionFilterProp="children"
            size="small"
          >
            {isArrayAndHasValue(styleList) &&
              styleList.map((item) => (
                <Option value={item.id} key={item.id}>
                  {item.style_no}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="CM Status" name="cm_status">
          <Select
            showSearch
            allowClear
            placeholder="Select CM Status"
            optionFilterProp="children"
            size="small"
          >
            {cmStatusOptions.map((item) => (
              <Option value={item.id} key={item.id}>
                {item.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="OB Status" name="ob_status">
          <Select
            showSearch
            allowClear
            placeholder="Select OB Status"
            optionFilterProp="children"
            size="small"
          >
            {obStatusOptions.map((item) => (
              <Option value={item.id} key={item.id}>
                {item.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={4}>
        <Form.Item label="Merchandiser" name="received_by">
          <Select
            showSearch
            allowClear
            placeholder="Select Merchandiser"
            onSearch={(value) => {
              getAllUsers({ name: value });
            }}
            optionFilterProp="children"
            size="small"
          >
            {isArrayAndHasValue(usersList) &&
              usersList.map((user) => (
                <Option value={user.id} key={user.id}>
                  {user.name}
                </Option>
              ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default BuyerInquiryFilterFields;
